export default __webpack_public_path__ + "static/media/books2-afterB-2048w.ea4ded47.png";